/**
 * @ComponentFor Avensia.Shop.Features.Pantries.Pages.List.Toolbar.PrintActions
 */
import React from "react";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
import Button from "Shared/Button";
import * as styles from "./printOptions.scss";
const PrintActions = (props) => {
    return (props.visible && (React.createElement("div", { className: styles.buttonWrapper },
        React.createElement(Button, { disabled: !props.listsSelected, className: styles.printButton, onClick: (e) => {
                document.getElementById("Print").submit();
            } }, translate("/Account/ProductList/PrintOptions/Print")),
        React.createElement("form", { id: "Print", method: "post", target: "_blank", action: props.reportPageUrl + "print" },
            React.createElement("input", { type: "hidden", name: "reportType", value: props.reportType }),
            React.createElement("input", { type: "hidden", name: "listids", value: JSON.stringify(props.selectedLists) })),
        React.createElement(Button, { disabled: !props.listsSelected, className: styles.printButton, onClick: (e) => {
                document.getElementById("Excel").submit();
            } }, translate("/Account/ProductList/PrintOptions/Excel")),
        React.createElement("form", { id: "Excel", method: "post", target: "_blank", action: props.reportPageUrl + "excel" },
            React.createElement("input", { type: "hidden", name: "reportType", value: props.reportType }),
            React.createElement("input", { type: "hidden", name: "listids", value: JSON.stringify(props.selectedLists) })))));
};
export default connect(({ currentPage, appShellData }) => {
    return {
        listsSelected: currentPage.lists
            ? currentPage.lists.some((list) => list.selected)
            : false,
        selectedLists: currentPage.lists
            ? currentPage.lists
                .filter((x) => x.selected === true)
                .map((a) => {
                return { id: a.id };
            })
            : [],
        reportPageUrl: appShellData.siteSettings.pantryReportPage.url,
    };
})(PrintActions);
